export default "__VITE_ASSET__Ui2W1zhV__"